import React, { useState, useEffect, useRef } from 'react'
import { Link } from 'react-router-dom'
import Logofull from "src/assets/icons/logo-large.png";
import LoginBg from "src/assets/icons/login-gst.png";
import {
  CButton,
  CCard,
  CCardBody,
  CCardGroup,
  CCol,
  CContainer,
  CInput,
  CInputGroup,
  CRow
} from '@coreui/react'
import { Formik } from "formik"
import ToastMessage from "src/components/toast-message/ToastMessage";
import * as yup from "yup"
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { userLogin, emailVerify, initUserProfileData, saveSocialAuthData, appleAuth } from 'src/actions/registration';
// import {pushNotiUserJoined} from "src/actions/push-notification"
// import TwitterLogin from "react-twitter-login";
import cookie from 'react-cookies'
import { BroadcastChannel } from 'broadcast-channel';
import { Toast } from 'primereact/toast';
import { useLocation } from "react-router-dom";
import { GET_USER_COMPANIES_IN_LOGIN_SUCCESS } from 'src/actions/actionTypes';
import { GoogleLogin } from 'react-google-login';
import FacebookLogin from 'react-facebook-login';
import AppleSignin from 'react-apple-signin-auth';
import { appleRedirectUri, googleClientId, googleRedirectUri } from "src/util/globalUrls";

const Login = () => {
  const location = useLocation();
  const toast = useRef(null);
  const [loginToken, setLoginToken] = useState('initail value')
  const [showToast, setshowToast] = useState(false);
  const [responseMsg, setResponseMsg] = useState('');
  const [ToastSeverity, setToastSeverity] = useState('');
  const [loader, setLoader] = useState(false);

  const saveSocialAuthStatus = useSelector(state => state.registration?.saveSocialAuthStatus)
  const initLoginData = useSelector(state => state.registration?.loginUserData)
  const loginUserData = useSelector(state => state.userReduser?.loginUserData)
  const bookFromDateToDate = useSelector(state => state.userReduser?.bookStartDateEndDate)

  const channel = new BroadcastChannel('loginReload');
  useEffect(() => {
    channel.onmessage = msg => {
      if (msg == "login") {
        window.location.reload()
      }
    }
    return () => {
      channel.close()
    }
  }, [channel])
  const dispatch = useDispatch()
  const history = useHistory()
  const loginData = useSelector(state => state.registration?.loginUserDataNew)
  const verifyEmailResp = useSelector(state => state.registration?.verifyEmailResp)
  const anyDeskSuccess = useSelector((state) => state.miscReducer.anyDeskSuccess);


  const [userToken, setUserToken] = useState('')
  useEffect(() => {
    let params = new URLSearchParams(location.search);
    var token = params.get('token')
    // setLoginToken(params.get('token'))
    if (token) {
      dispatch(emailVerify({ "token": token }))
      setUserToken(token)

    }
  }, [location])

  useEffect(() => {
    if (verifyEmailResp && Object.keys(verifyEmailResp).length > 0) {
      setResponseMsg(verifyEmailResp.response)
      if (verifyEmailResp.status == false) {
        setToastSeverity('error')
        // history.push("/email-verification-failed")
        history.push({
          pathname: 'email-verification-failed',
          search: `?token=${userToken}`,
        })


      } else if (verifyEmailResp.status == true) {
        // setToastSeverity('success')
        history.push("/email-verification-success")
      } else {
        setResponseMsg('Something went wrong');
        setToastSeverity('error');
        history.push("/email-verification-failed")

      }
      setshowToast(true);
    }
  }, [verifyEmailResp])
  useEffect(() => {
    if (initLoginData && initLoginData.length != 0) {
      if (initLoginData?.loginValidateStatus) {
        channel.postMessage('login');
        dispatch({ type: GET_USER_COMPANIES_IN_LOGIN_SUCCESS, payload: initLoginData });
        const data = {
          userName: initLoginData.userName,
          userId: initLoginData.userId,
          userEmail: initLoginData.userEmail,
          auth_type: initLoginData.auth_type
        }
        cookie.save("GST_USER_DATA", data, { path: '/' })
        // cookie.save("GST_USER_DATA", data, { path: '/' })
        // if (initLoginData?.tallyCompaniesList?.length > 0) {
        //   history.push("/authentication")
        //   cookie.save('SELECTED_COMPANY', initLoginData?.tallyCompaniesList[0]?.companyName, { path: '/' })
        //   cookie.save('SELECTED_TCUUID', initLoginData?.tallyCompaniesList[0]?.tcUuid, { path: '/' })
        //   cookie.save('TENANT', initLoginData?.tallyCompaniesList[0]?.tallySchema, { path: '/' })
        //   // dispatch(getBookStartAndEndDate())
        //   dispatch(initUserProfileData({ "user_id": initLoginData.userId }));
        // } else {
        //   history.push("/no-companies-found")
        // }


        if (initLoginData?.gst_users?.length > 0) {
          // history.push("/authentication")

          cookie.save('SELECTED_GSTIN_LIST', initLoginData?.gst_users, { path: '/' });
          dispatch({ type: "SELECTED_GSTIN_LIST_STORE", payload: initLoginData?.gst_users });
          cookie.save('SELECTED_GSTIN_DETAIL', initLoginData?.gst_users[0], { path: '/' });
          dispatch(initUserProfileData({ "user_id": initLoginData.userId }));

          history.push("/dashboard")

        } else {
          history.push("/no-gst")
        }

      } else {
        if (initLoginData?.response) {
          setToastSeverity('error')
          setResponseMsg(initLoginData?.response)
          setshowToast(true);
        } else {
          setToastSeverity('error')
          setResponseMsg("Something went wrong")
          setshowToast(true);
        }

      }
      setLoader(false)
    }



  }, [initLoginData])



  useEffect(() => {

    if (cookie.load("GST_USER_DATA")) {
      if (cookie.load("SELECTED_GSTIN_DETAIL")) {
        // history.push("/authentication");
        history.push("/dashboard")
      } else {
        history.push("/no-gst")
      }
    }

  }, [loginUserData])

  const validationSchema = yup.object().shape({
    email: yup
      .string()
      .email()
      .required("Email is required"),
    password: yup
      .string()
      .min(2)
      .required("Password is required")
  })


  const onUserLogIn = (values) => {
    setshowToast(false);
    setLoader(true)
    dispatch(userLogin(values.email, values.password))
  }

  const pushNotiUserJoinedHandler = () => {
    const userJoinedData = {
      "username": initLoginData.userName,
      "user_email": initLoginData.userEmail,
      "url": `https://app.tallyinsider.com/?#/dashboard`
    }

    // dispatch(pushNotiUserJoined(userJoinedData))
    //   axios.post('https://abca3543aa81.ngrok.io/api/inviteUserJoined/', userJoinedData).then(

    //   (res) =>
    //     {
    //       console.log(res,"------response")
    //     },
    //   (err) =>{
    //     console.log(err,"------response")

    //   }
    // );
  }

  useEffect(() => {
    if (loginData && Object.keys(loginData).length > 0) {
      setResponseMsg(loginData.response)
      if (loginData.status == false) {
        setToastSeverity('error')
      } else if (loginData.status == true) {
        setToastSeverity('success');
        history.push("/authentication")
      } else {
        setResponseMsg('Something went wrong');
        setToastSeverity('error');
      }
      setshowToast(true);
    }
  }, [loginData])

  const handleSocialLogin = (value) => {
    const data = {
      "login_type": value
    }
    fetch(`http://10.100.1.88:9333/socialauthlogin`, data)
      .then((data) => data.json())
      .then((data) => {
        console.log(data)
      })
  }



  // dummy flow of code for google login
  const responseGoogle = (response) => {

    if (response?.profileObj) {
      const data = {
        userName: response?.profileObj?.name,
        userId: response?.profileObj?.googleId,
        userEmail: response?.profileObj.email
      }
      const qData = {
        "email": response?.profileObj?.email,
        "user_name": response?.profileObj?.name,
        "auth_type": "google",
        "first_name": response?.profileObj?.givenName,
        "last_name": response?.profileObj?.familyName,
      }
      dispatch(saveSocialAuthData(qData))
      // cookie.save("GST_USER_DATA", data, { path: '/' })
      // cookie.save("GST_USER_DATA", data, { path: '/' })
      // history.push("/authentication")


    }
  }

  const appleAuthSuccess = (response) => {
    if (response.hasOwnProperty('user')) {
      dispatch(appleAuth({
        id_token: response.authorization.id_token,
        user_obj: {
          name: { firstName: response.user.name.firstName, lastName: response.user.name.lastName }, email: response.user.email
        }
      }))
    } else {
      dispatch(appleAuth({
        id_token: response.authorization.id_token,
        user_obj: null
      }))
    }
  }

  useEffect(() => {
    if (saveSocialAuthStatus && saveSocialAuthStatus?.length != 0) {
      if (saveSocialAuthStatus?.loginValidateStatus) {
        dispatch({ type: GET_USER_COMPANIES_IN_LOGIN_SUCCESS, payload: saveSocialAuthStatus });
        const data = {
          userName: saveSocialAuthStatus.userName,
          userId: saveSocialAuthStatus.userId,
          userEmail: saveSocialAuthStatus.userEmail,
          auth_type: saveSocialAuthStatus.auth_type
        }
        cookie.save('GST_USER_DATA', data, { path: '/' })
        if (saveSocialAuthStatus?.gst_users?.length > 0) {
          // history.push("/authentication")
          cookie.save('SELECTED_GSTIN_LIST', saveSocialAuthStatus?.gst_users, { path: '/' });
          dispatch({ type: "SELECTED_GSTIN_LIST_STORE", payload: saveSocialAuthStatus?.gst_users });
          cookie.save('SELECTED_GSTIN_DETAIL', saveSocialAuthStatus?.gst_users[0], { path: '/' });
          dispatch(initUserProfileData({ "user_id": saveSocialAuthStatus.userId }));
          history.push("/dashboard")
        } else {
          history.push("/no-gst")
        }
        channel.postMessage("login");
      } else {
        if (saveSocialAuthStatus?.response) {
          setToastSeverity('error')
          setResponseMsg(saveSocialAuthStatus?.response)
          setshowToast(true);
        } else {
          setToastSeverity('error')
          setResponseMsg("Something went wrong")
          setshowToast(true);
        }

      }
    }

  }, [saveSocialAuthStatus])
  const authHandler = (err, data) => {
    console.log(err, data);
  };

  const responseFacebook = (response, scope) => {
    console.log(response);
    if (response?.status != "unknown") {
      const data = {
        userName: response?.name,
        userId: response?.googleId,
        userEmail: response?.userID,
      }
      const qData = {
        "email": response?.email,
        "userName": response?.name,
        "auth_type": "facebook",
        "firstName": response?.name.split(" ")[0],
        "lastName": response?.name.split(" ")[1],
      }
      // dispatch(saveSocialAuthData(qData))
      cookie.save("GST_USER_DATA", data, { path: '/' })
      // cookie.save("GST_USER_DATA", data, { path: '/' })
      // history.push("/authentication")


    }
  }

  const [visibilityPassWord, setVisibilityPassWord] = useState(false);


  useEffect(() => {

    if (anyDeskSuccess === true) {

      toast.current.show({
        severity: 'success',
        summary: 'Support',
        detail: "Support request submitted succesfully",
        life: 3000
      });

      dispatch({ type: "ANY_DESK_SUPPORT_SUCCESS", payload: false });
    }

  }, [anyDeskSuccess]);


  return (
    <>

      <div className="toast-mess">
        <Toast ref={toast} />
      </div>

      {showToast && (
        <ToastMessage
          severity={ToastSeverity}
          summary={!ToastSeverity ? "Success" : "Error"}
          detail={responseMsg}
        />
      )}

      <div className="gradient-color">
        <div className="header fixed-top mobile-fixed-top">
          <div className="container-fluid">
            <div className="row">
              <div className="col-xl-8 col-lg-6 col-md-6 col-sm-6 col-8 mt-3">
                <img src={Logofull} className="c-sidebar-brand-full mobile-logo-width img-fluid" />{" "}
              </div>
              <div className="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-4 text-right mt-3">
                {/* <butston className="btn btn-outline-dark  btn-md outline-btn-width long-btn bold-label"><i className="fa fa-sign-in" aria-hidden="true"></i> Switch to Finsights App</button> */}
              </div>
            </div>
          </div>
        </div>

        <div className="c-app c-default-layout flex-row align-items-center no-card-bg login-ill login-bottom-b">
          <div className="container-fluid max-container-width">
            <CRow className="justify-content-center">
              <CCol xl="12" lg="12" md="12" sm="12">
                <CCard className="mobile-shadow mt-0 border-0 no-card-bg mb-0">
                  <CCardBody className="mobile-padding">
                    <CCardGroup className="align-items-center">
                      <CCard className="d-md-down-none border-0 no-card-bg  inside-border-radius">
                        <CCardBody className="text-left">
                          <img
                            src={LoginBg} className="c-sidebar-brand-full mobile-logo-width img-fluid" />
                          {/* <div className="mt-2">
                            <p className="status-font mb-2 font-size-24 normal-demo-text">Don't have an account?</p>
                            <div className="mt-2">
                              <Link to="/register" className="btn btn-dark sign-btn-hover outline-btn-width hover-text text-white shadow-none border-radius-25 status-font">Register Now <i className="fas fa-angle-right m-0"></i></Link>
                            </div>
                          </div> */}
                          <div className="mt-3">
                            <p className="font-size-18 bold-label mb-3">Automate your ITC Reconciliation</p>
                            <p className="font-size-14 status-font normal-demo-text mb-2"><i className="fas fa-check-circle text-dark"></i> Avail Max ITC</p>
                            <p className="font-size-14 status-font normal-demo-text mb-2"><i className="fas fa-check-circle text-dark"></i> Automatic Daily Reconciliation of Books with GSTR2A & GSTR2B</p>
                            <p className="font-size-14 status-font normal-demo-text mb-2"><i className="fas fa-check-circle text-dark"></i> AI based Matching</p>
                          </div>
                        </CCardBody>
                      </CCard>
                      <CCard className="border-0 no-card-bg">
                        <CCardBody className="mobile-padding login-forms p-5">
                          <div className="row justify-content-center">
                            <div className="col-xl-10 col-lg-12 col-md-12">
                              <div className="card border-0 no-card-b bg-white shadow-sm border-radius-10px">
                                <div className="card-body pl-5 pr-5 pt-4 pb-4">
                                  <div className="mb-0 text-left">
                                    <h3 className="status-font large-extra-font">Log In</h3>
                                    <h6 className="mb-0 d-block font-size-12">Don't have an account? <Link to="/register" className="text-primary bold-label">Register Now</Link></h6>
                                  </div>
                                  <Formik
                                    initialValues={{
                                      email: "",
                                      password: "",
                                    }}
                                    validationSchema={validationSchema}
                                    onSubmit={((values, errors) => {
                                      onUserLogIn(values)
                                    })}
                                  >
                                    {({ handleChange, handleSubmit, handleBlur, values, errors, touched }) => (
                                      <form onSubmit={handleSubmit}>

                                        <CInputGroup className="mb-3 mt-4">
                                          <CInput type="text" placeholder="Email" onChange={handleChange} name="email" autoComplete="email" className=" rounded-pil light-login-b h-50p b-r-3 form-control-lg  border-r-b custom-input" />
                                          <i className="fas fa-envelope inside-icon"></i>
                                        </CInputGroup>
                                        {errors.email && touched.email ? (<div className="mb-1 sign-error-msgs text-danger text-left">{errors.email}</div>) : null}
                                        <CInputGroup className="mb-1">
                                          <CInput type={visibilityPassWord ? "text" : "password"} name="password" onChange={handleChange} placeholder="Password" autoComplete="current-password" className=" rounded-pil light-login-b h-50p b-r-3 form-control-lg  border-r-b custom-input" />
                                          {!values?.password && <i className="fas fa-key inside-icon"></i>}
                                          {!visibilityPassWord && values?.password && <i className="fa fa-eye inside-icon c-pointer" aria-hidden="true" onClick={e => setVisibilityPassWord(!visibilityPassWord)}></i>}
                                          {visibilityPassWord && values?.password && <i className="fa fa-eye-slash inside-icon c-pointer" aria-hidden="true" onClick={e => setVisibilityPassWord(!visibilityPassWord)}></i>}
                                        </CInputGroup>
                                        {errors.password && touched.password ? (<div className="mb-1 sign-error-msgs text-danger text-left">{errors.password}</div>) : null}
                                        <CRow>
                                          <CCol md="12" xl="12" lg="12" className="mt-0 align-text-center text-right ">
                                            <Link to="/forgot-password" className="text-dark min-font-size"><CButton className="font-size-12 px-0 text-dark status-font btn-block shadow-none"> Forgot password?</CButton></Link>
                                          </CCol>
                                          {!loader && <CCol md="12" xl="12" lg="12" className="align-text-center">
                                            <CButton type="submit" color="primary" className="px-4 btn-block shadow-none rounded-pil btn-lg"><i className="fas fa-key"></i> Login</CButton>
                                          </CCol>}
                                          {loader && <CCol md="12" xl="12" lg="12" className="align-text-center">
                                            <CButton type="submit" color="primary" className="px-4 btn-block shadow-none rounded-pil btn-lg"><i className="fa fa-circle-o-notch fa-spin"></i> Login</CButton>
                                          </CCol>}


                                        </CRow>
                                      </form>
                                    )}
                                  </Formik>
                                  <div className="rounded-social-buttons  mobil-block mb-0">
                                    <div className="">
                                      <div className="">
                                        <div className="form-group col-lg-12 mx-auto d-flex align-items-center my-4">
                                          <div className="border-bottom-light-c w-100 ml-5"></div>
                                          <span className="px-2 small text-muted font-weight-bold text-muted">OR</span>
                                          <div className="border-bottom-light-c w-100 mr-5"></div>
                                        </div>
                                        {/* <h6 className="mb-2 bold-label">Login With</h6> */}
                                        <div className="shadow-for-google">
                                          <div>
                                            <GoogleLogin
                                              clientId={googleClientId}
                                              buttonText="Sign in with Google"
                                              onSuccess={responseGoogle}
                                              className="gst-google-btn"
                                              onFailure={responseGoogle}
                                              cookiePolicy={'single_host_origin'}
                                              redirectUri={googleRedirectUri}
                                            />
                                          </div>
                                        </div>
                                        <div>

                                          <AppleSignin
                                            /** Auth options passed to AppleID.auth.init() */
                                            authOptions={{
                                              clientId: "biz.finsights.app.sid",
                                              redirectURI: appleRedirectUri,

                                              scope: 'email name',
                                              state: 'state',
                                              nonce: 'nonce',
                                              usePopup: true,
                                            }}
                                            uiType="light"
                                            className="apple-auth-btn mt-2"
                                            onSuccess={(response) => { appleAuthSuccess(response) }}
                                            onError={(error) => {
                                              console.error(error)
                                            }}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </CCardBody>
                      </CCard>
                    </CCardGroup>
                  </CCardBody>
                </CCard>
              </CCol>
            </CRow>
          </div>
        </div>
      </div>
    </>
  )
}


export default Login
